import { createActorContext } from "@xstate/react3"
import importUsersMachine from "./importUsers"

const ImportUsersMachineContext = createActorContext(importUsersMachine)

export default ImportUsersMachineContext
